import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
const AppMenuContent = (props) => {
    const { appMenuItems, appNavigator } = props;
    // In case there is a navigation component injected into the header,
    // render this component
    if (appNavigator) {
        return (_jsx("li", Object.assign({ role: 'presentation' }, { children: appNavigator }), 'app-navigator'));
    }
    // If there is a list of appMenuItems given, render them as a list
    return (_jsx(_Fragment, { children: appMenuItems.map(module => {
            return (_jsx("li", Object.assign({ role: 'presentation' }, { children: module.route }), `link-icon-${module.key}`));
        }) }));
};
export default AppMenuContent;
